<template>
  <vue-modal
    :model-value="modelValue"
    @close="$emit('update:modelValue', false)"
  >
    <div class="modal-content flex flex-col items-center gap-4 p-4 sm:p-8 pt-0 sm:pt-0 text-center overflow-hidden">
      <!-- Green arc header with product image -->
      <div class="relative flex flex-col items-center -mx-4 sm:-mx-8 rounded-t-2xl h-[218px] w-[calc(100%+2rem)] sm:w-[calc(100%+4rem)] overflow-hidden">
        <div class="flex-center absolute bg-green-300 w-[700px] h-[600px] -top-[400px] rounded-[50%] pointer-events-none overflow-hidden">
          <img
            v-if="upsell.product?.featured_image"
            :src="upsell.product.featured_image"
            :alt="upsell.product?.title"
            class="z-10 w-[273px] h-[276px] absolute -bottom-15 object-contain"
            width="273"
            height="276"
          >
        </div>
      </div>

      <h2 class="text-3xl font-semibold -mt-4 text-center">
        Want More Protein?
      </h2>

      <p class="text-neutral-900 text-center">
        Add an extra 10g with The Protein Pack.<br>
        Crafted specifically to mix with all flavors.<br>
        Only $1.25 per pack.
      </p>

      <div class="flex flex-col gap-1">
        <div class="flex flex-wrap gap-1 justify-center">
          <div
            v-for="ingredient in upsell.ingredients"
            :key="ingredient"
            class="bg-neutral-100 text-neutral-700 py-1 px-2.5 rounded text-nowrap"
          >
            {{ ingredient }}
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-2 w-full">
        <DisclosureButton
          class="+large +green w-full"
          :value="upsell.upsellPriceCents"
          @click="handleAdd"
        >
          Add {{ upsell.displayPackCount }} Packs
        </DisclosureButton>
      </div>

      <button
        class="font-semibold text-blue-500 p-2"
        @click="openPdp"
      >
        Nutrition Facts
      </button>
    </div>
  </vue-modal>
</template>

<script setup lang="ts">
import { useProteinPackUpsellStore } from '@/stores'
import { useThemeStore } from '@/stores'
import VueModal from '@/components/theme/render/vue-modal.vue'
import DisclosureButton from './disclosure-button.vue'
import ProteinPackPdpModal from './protein-pack-pdp-modal.vue'

defineProps<{ modelValue: boolean }>()
const emit = defineEmits<{ 'update:modelValue': [value: boolean] }>()

const upsell = useProteinPackUpsellStore()
const { sheet, modal } = useThemeStore()

const handleAdd = () => {
  upsell.add()
  emit('update:modelValue', false)
}

const openPdp = () => {
  emit('update:modelValue', false)
  const isMobile = window.innerWidth < 640
  if (isMobile) {
    sheet.open(ProteinPackPdpModal, { mode: 'sheet' })
  } else {
    modal.open(ProteinPackPdpModal, { mode: 'modal' })
  }
}
</script>
